import React, { useEffect } from 'react';
import { Link } from 'react-scroll'; // Import for smooth scroll
import AppRoutes from './Routes';

function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div>
      <AppRoutes />
    </div>
  );
}

export default App;


